import { useThree } from "@react-three/fiber";
import { useEffect } from "react";

function CanvasCapture({ onCaptureReady }) {
  const { gl, scene, camera } = useThree();
  
  useEffect(() => {
    const capture = () => {
      gl.render(scene, camera);
      
      // Create a new canvas with background color
      const webglCanvas = gl.domElement;
      const captureCanvas = document.createElement('canvas');
      captureCanvas.width = webglCanvas.width;
      captureCanvas.height = webglCanvas.height;
      const ctx = captureCanvas.getContext('2d');
      
      // Solid backing for exports (GIF / PNG); white reads cleanly off-app
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, captureCanvas.width, captureCanvas.height);
      
      // Draw the WebGL canvas on top
      ctx.drawImage(webglCanvas, 0, 0);
      
      return captureCanvas.toDataURL("image/png");
    };
    
    onCaptureReady(capture);
  }, [gl, scene, camera, onCaptureReady]);
  
  return null;
}

export default CanvasCapture;

